export const AGENT_PLATFORM_BASE = '/agent-platform';
